var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorStand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 49,
    viewBox: "0 0 63 49",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1318 0C39.787 2.08234 38.7127 3.97481 37.1003 5.34012C35.4879 6.70544 33.4422 7.45488 31.3279 7.45488C29.2135 7.45488 27.1679 6.70544 25.5555 5.34012C23.9431 3.97481 22.8688 2.08234 22.524 0H0V48.7261H62.6568V0H40.1318Z",
    fill: "#D4D4D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorStand);
export default __webpack_public_path__ + "static/media/error-stand.7476e88fa44901a73b52529e88759425.svg";
export { ForwardRef as ReactComponent };